import { defineComponent } from 'vue';
export default defineComponent({
  name: 'FaqFooter',
  data() {
    return {
      mintDate: new Date('May 25, 2023')
    };
  }
});